import { gql } from "@apollo/client";

export interface ResetVars {
  username: string;
  PreviousPassword: string;
  ProposedPassword: string;
}
export interface ResetResponse {
  done: boolean;
}

export const GET_RESET = gql`
  mutation ChangePassword(
    $username: String!
    $PreviousPassword: String!
    $ProposedPassword: String!
  ) {
    changePassword(
      data: {
        username: $username
        PreviousPassword: $PreviousPassword
        ProposedPassword: $ProposedPassword
      }
    ) {
      done
    }
  }
`;

export const GET_USER_NOTIFICATION_PREFERENCE = gql`
  query GetUserNotificationPreference($userId: Int!) {
    userNotificationPreference(userId: $userId) {
      userId
      emailEnabled
    }
  }
`;

export const UPDATE_EMAIL_NOTIFICATION_PREFERENCE = gql`
  mutation UpdateUserNotificationPreferences($userId: Int!, $input: UpdateNotificationPreferenceDto!) {
    updateUserNotificationPreferences(userId: $userId, input: $input) {
      id
      emailEnabled
    }
  }
`;

export interface GetUserNotificationPreferenceResponse {
  userNotificationPreference: {
    userId: number;
    emailEnabled: boolean;
  } | null;
}

export interface UpdateEmailNotificationResponse {
  updateUserNotificationPreferences: {
    id: number;
    emailEnabled: boolean;
  };
}

export interface UpdateEmailNotificationVars {
  userId: number;
  input: {
    emailEnabled: boolean;
  };
}
